import { Reveal, MaskedLine } from './Reveal';

export const PageHero = ({ eyebrow, title, copy, image, imageAlt, children }) => (
  <section data-testid="page-hero" className="relative overflow-hidden bg-paper pt-32 sm:pt-40">
    <div
      className="pointer-events-none absolute -right-32 -top-24 h-[420px] w-[420px] rounded-full bg-forest/10 blur-[100px]"
      aria-hidden="true"
    />
    <div className="relative mx-auto max-w-7xl px-5 pb-16 sm:px-8 sm:pb-24">
      <div className={`grid items-center gap-12 ${image ? 'lg:grid-cols-[1.1fr_0.9fr]' : ''}`}>
        <div>
          <Reveal>
            <div className="mb-6 flex items-center gap-4">
              <span className="gold-rule" aria-hidden="true" />
              <span className="eyebrow">{eyebrow}</span>
            </div>
          </Reveal>
          <h1 className="text-balance font-display text-4xl font-bold leading-[1.08] tracking-tight text-ink sm:text-5xl lg:text-6xl">
            <MaskedLine delay={0.1}>{title}</MaskedLine>
          </h1>
          {copy && (
            <Reveal delay={0.3}>
              <p className="mt-6 max-w-xl text-base leading-relaxed text-ink sm:text-lg">{copy}</p>
            </Reveal>
          )}
          {children && <Reveal delay={0.4}>{children}</Reveal>}
        </div>
        {image && (
          <Reveal delay={0.25} className="relative">
            <div className="absolute -left-4 -top-4 h-full w-full rounded-2xl border border-gold/50" aria-hidden="true" />
            <div className="img-frame aspect-[4/3] shadow-[0_36px_80px_-32px_rgba(0,59,36,0.45)]">
              <img src={image} alt={imageAlt || ''} loading="eager" />
            </div>
          </Reveal>
        )}
      </div>
    </div>
  </section>
);
